export default __webpack_public_path__ + "static/media/logokey.31eea260.svg";